/**
 * @Author: Calvin Green <calvin>
 * @Date:   2022-03-01T13:12:28+02:00
 * @Email:  calvin@diversitude.com
 * @Last modified by:   calvin
 * @Last modified time: 2022-04-11T13:01:32+02:00
 * @Copyright: Diversitude 2022
 */

//import window.axios from "window.axios";

//const base = process.env.VUE_APP_API_BASEURL;

export const state = {
    location_types: [],
    supplier_types: [],
    folia_locations: [],
    facility_view: 'none',
    client_locations: [],
    client_suppliers: [],

    all_audits: [],
    client_audit: null,
    selected_audit: -1,
    selected_audit_session_id: -1,
    selected_audit_session_data: null,
};

export const mutations = {
    setLocationTypes(state, payload){
        state.location_types = payload;
    },
    setSupplierTypes(state, payload) {
        state.supplier_types = payload;
    },
    setClientLocations(state, payload){
        state.client_locations = payload;
    },
    setFoliaLocations(state, payload) {
        state.folia_locations = payload;
    },
    setClientSuppliers(state, payload){
        state.client_suppliers = payload;
    },
    resetStore(state, payload){
        state.location_types = payload;
        state.client_locations = payload;
        state.client_suppliers = payload;
        state.all_audits = [];
    },
    setView(state, payload){
        state.facility_view = payload;
    },
    //eslint-disable-next-line
    clearAll(state, payload){
        state.facility_view = 'none';
        state.all_audits = [];
    },
    clearAuditData(state){
        state.all_audits = [];
        state.client_audit = null;
        state.selected_audit = -1;
    },

    //* Audits
    setAllAudits(state, payload){
        state.all_audits = payload;
    },
    setClientAuditData(state, payload){
        state.client_audit = payload;
    },
    setSelectedAuditId(state, payload){
        state.selected_audit = payload;
    },
    setSelectedSessionId(state, payload){
        state.selected_audit_session_id = payload;
    },
    setSelectedAuditSessionData(state, payload){
        state.selected_audit_session_data = payload;
    }
};

export const actions = {
    //eslint-disable-next-line
    //getEvidencePreviewLink({}, evidence_id){
    //    return new Promise((resolve, reject) => {
    //        
    //    })
    //},

    //eslint-disable-next-line
    deleteEvidenceFile({}, evidence_id){
        return new Promise((resolve, reject) => {
            window.axios.post(`api/facilityaudits/deleteevidence`, { evidence_id: evidence_id } )
            .then(()=>{
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        })
    },
    getAvailableAudits({commit}){
        return new Promise((resolve, reject) => {
            window.axios.get('api/facilityaudits/availableaudits')
            .then((response)=>{
                commit('setAllAudits', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        })
    },
    getClientAudit({commit}, audit_id){
        return new Promise((resolve, reject) => {
            window.axios.get(`api/facilityaudits/clientaudit/${audit_id}`)
            .then((response)=>{
                commit('setClientAuditData', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        })
    },
    getClientAuditSessionData({commit}, session_id){
        return new Promise((resolve, reject) => {
            window.axios.get(`api/facilityaudits/clientauditsession/${session_id}`)
            .then((response)=>{
                commit('setSelectedAuditSessionData', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        })
    },
    startNewAuditSession({commit}, audit_id){
        return new Promise((resolve, reject) => {
            window.axios.post(`api/facilityaudits/startsession`, {client_audit_id: audit_id})
            .then((response)=>{
                commit('setSelectedSessionId', response.data.session_id)
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        })
    },
    //eslint-disable-next-line
    saveAuditSessionForm({}, payload){
        return new Promise((resolve, reject) => {
            window.axios.post(`api/facilityaudits/savesessiondata`, payload )
            .then(()=>{
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        })
    },
    //eslint-disable-next-line
    endAuditSession({}, session_id) {
        return new Promise((resolve, reject) => {
            window.axios.post(`api/facilityaudits/endsession`, {audit_session_id: session_id})
            .then((response)=>{
                resolve(response.data);
            })
            .catch((e)=>{
                reject(e);
            })
        })
    },
    //eslint-disable-next-line
    deleteAuditSession({commit, state}, session_id){
        return new Promise((resolve, reject) => {
            window.axios.post(`api/facilityaudits/deletesession`, {audit_session_id: session_id})
            .then(()=>{
                if(session_id == state.selected_audit_session_id){
                    commit('setSelectedSessionId', -1);
                    commit('setSelectedAuditSessionData', null);
                }
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        })
    },
    setSelectedAuditID({commit}, audit_id){
        return new Promise((resolve)=>{
            // reset vars on update
            commit('setSelectedSessionId', -1);
            commit('setSelectedAuditSessionData', null);

            commit('setSelectedAuditId', audit_id);
            resolve();
        })
    },
    setSelectedSessionID({commit}, session_id){
        return new Promise((resolve) => {
            if(session_id == -1){
                commit('setSelectedAuditSessionData', null);
            }
            commit('setSelectedSessionId', session_id);
            resolve();
        })
    },

    loadLocationTypes({commit}){
        return new Promise((resolve, reject)=>{
            window.axios.get('api/facilityadmin/locationtypes')
            .then((response)=>{
                commit('setLocationTypes', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    loadSupplierTypes({commit}){
        return new Promise((resolve, reject)=>{
            window.axios.get('api/facilityadmin/suppliertypes')
            .then((response)=>{
                commit('setSupplierTypes', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    loadFoliaLocations({commit}) {
        return new Promise((resolve, reject)=>{
            window.axios.get('api/folialink/locations')
            .then((response)=>{
                commit('setFoliaLocations', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    loadClientLocations({commit}){
        return new Promise((resolve, reject)=>{
            window.axios.get('api/facilityadmin/clientlocations')
            .then((response)=>{
                commit('setClientLocations', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    loadClientSuppliers({commit}){
        return new Promise((resolve, reject)=>{
            window.axios.get('api/facilityadmin/clientsuppliers')
            .then((response)=>{
                commit('setClientSuppliers', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    /*eslint-disable-next-line*/
    saveClientLocation({}, params){
        /* id, location_type_id, location_name, location_sqm */
        return new Promise((resolve, reject) => {
            window.axios.post('api/facilityadmin/saveclientlocation', params)
            .then(()=>{
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    /*eslint-disable-next-line*/
    deleteClientLocation({}, params){
        /* id, location_type_id, location_name, location_sqm */
        return new Promise((resolve, reject) => {
            window.axios.post('api/facilityadmin/deleteclientlocation', params)
            .then(()=>{
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    /*eslint-disable-next-line*/
    saveClientSupplier({}, params){
        /* id, company_name, company_address, tel_no, fax_no, company_email, contact_person, activity_desc */
        return new Promise((resolve, reject) => {
            window.axios.post('api/facilityadmin/saveclientsupplier', params)
            .then(()=>{
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    /*eslint-disable-next-line*/
    linkLocationSupplier({}, params){
        /* location_id, supplier_id */
        return new Promise((resolve, reject) => {
            window.axios.post('api/facilityadmin/linklocationsupplier', params)
            .then(()=>{
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    /*eslint-disable-next-line*/
    deleteSupplierSLA({}, params){
        /* location_id, supplier_id */
        return new Promise((resolve, reject) => {
            window.axios.post('api/facilityadmin/deletesuppliersla', params)
            .then(()=>{
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    /*eslint-disable-next-line*/
    deleteClientSupplier({}, params) {
        return new Promise((resolve, reject) => {
            window.axios.post('api/facilityadmin/deleteclientsupplier', params)
            .then(()=>{
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    /*eslint-disable-next-line*/
    getSupplierSLAPreviewLink({}, params){
        /* location_id, supplier_id */
        return new Promise((resolve, reject) => {
            window.axios.get('api/facilityadmin/slapreview/' + params.revision_id)
            .then((response)=>{
                resolve(response.data);
            })
            .catch(()=>{
                reject();
            })
        })
    },

    setFacilityView({commit}, type){
        return new Promise((resolve)=>{
            commit('setView', type);
            resolve();
        })
    },
    clearAll({commit}){
        return new Promise((resolve) => {
            commit('resetStore', null);
            resolve();
        })
    },
    clearAuditData({commit}){
        commit('clearAuditData');
    }
};
